import { useMemo } from 'react';
import { APICustomFieldDescription, FacetFieldConfig } from '../types';
import { generateBaseConfig, mergeConfigs } from '../utils';
import { INITIAL_VISIBLE_COUNT } from '../constants';
import { AnyObject, FilterObject } from '@common/types/queryState';

export const useDynamicFacets = <TEntity = AnyObject>(
    cfd: APICustomFieldDescription[] | undefined,
    overrides: FacetFieldConfig<TEntity>[] = [],
): FacetFieldConfig<TEntity>[] => {
    return useMemo(() => {
        const base = generateBaseConfig<TEntity>(cfd || []);
        const merged = mergeConfigs(base, overrides);

        return merged.map((config) => {
            if (config.type !== 'boolean') {
                return config;
            }

            const missingPreset: FilterObject = {
                label: 'missing',
                value: config.key,
                operator: 'missing',
            };

            return {
                ...config,
                maxVisibleValues: INITIAL_VISIBLE_COUNT,
                presets: [missingPreset, ...(config.presets || [])],
            } as FacetFieldConfig<TEntity>;
        });
    }, [cfd, overrides]);
};
